export default class KeyboardFocusable {

    constructor(el) {
        this.el = el;
    }

    focus() {
        this.el?.classList.add('wizy-active');
    }

    unfocus() {
        this.el?.classList.remove('wizy-active');
    }

    enter() {
        this.el?.click();
    }

    isVisible() {
        if (this.el) {
            return this.el.offsetParent !== null;
        }

        return false;
    }

}
